import styled from 'styled-components';

export const TableBody = styled.tbody``;
